module.exports = __webpack_public_path__ + "static/img/QRCode.4cd937b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/QRCode.jpg
// module id = x9wK
// module chunks = 7